// ** Framework imports
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

// ** Mui imports
import Box from "@mui/material/Box";
// ** Components imports
import { Navigation } from "@/components/navigation/Navigation.tsx";

// ** Hooks imports
import usePreferencesState from "@/store/hooks.ts";

// ** Config imports
import { navigationConfig } from "@/config/navigation.ts";
import { useIsVerticalMode } from "@/hooks/useIsVerticalMode.tsx";

export const Route = createFileRoute("/_dashboard")({
  component: PathlessLayoutComponent,
  beforeLoad: ({ context }) => {
    if (!context.session?.isAuthenticated) {
       
      throw redirect({
        to: "/login",
      });
    }
  },
});

function PathlessLayoutComponent() {
  const { contained } = usePreferencesState();
  const isVerticalMode = useIsVerticalMode({});
  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette.background.default,
        minHeight: "100vh",
        height: "100%",
        ...(isVerticalMode && {
          display: "flex",
          flexDirection: "row",
        }),
      })}
    >
      <Navigation />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          maxWidth: contained ? "xl" : "unset",
          width: `calc(100vh - ${navigationConfig.drawerWidth})`,
          mx: "auto",
          px: 2,
          pl: 2,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
